import styled from 'styled-components';
import { COLORS } from '../../../game/data/colors';

export const ToggleButton = styled.div<{ $active: boolean }>(({ $active }) => ({
  height: '1.5rem',
  fontSize: '0.8rem',
  borderRadius: '0.75rem',
  padding: '0 1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: COLORS.zinc_400,
  fontWeight: 600,

  backgroundColor: $active ? COLORS.zinc_700 : 'transparent',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: COLORS.zinc_700,
  },
}));
